<div class="video-teaser" [ngClass]="{'list-bg': fromList
   }" *ngIf="video">
  <a title="{{ video.title }}" [routerLink]="['/play',video.key]">
    <div class="v-content d-block position-relative" [ngClass]="{'list': listStyle}">
      <div class="recommended" *ngIf="video.recommended"></div>
      <div class="top-right-icon">
        <div class="high-res" *ngIf="video.vipResource === '4K' || video.vipResource === '2K'"
          [ngClass]="{'icon-4K': video.vipResource === '4K', 'icon-2K': video.vipResource === '2K'}">
        </div>
        <div class="updated" *ngIf="video.updates && video.updates > 0">{{ video.atypeName === '电影' ? '新' :
          video.updates }}</div>
      </div>
      <img class="poster d-block" src="{{'./assets/images/loading_238x340.png'|absUrl}}"
        dataSrc="{{video.image | safeResource }}?w=238&h=340&format=jpg&mode=stretch" [lazyLoad]
        alt="{{ video.title}}" />
      <div class="bar"></div>
      <!-- <div class="rating" *ngIf="video.rating !== '0'">{{video.rating}}</div> -->
      <!-- <div class="rating" style="font-size: 14px;" *ngIf="!!video.score && video.score === '暂无评分'">暂无</div> -->
      <div class="rating" *ngIf="!!video.score && video.score !== '暂无评分'">{{ video.score }}</div>
    </div>
  </a>
  <div class="title-box" [ngClass]="{'list-bg': fromList}">
    <div class="title"><a [routerLink]="[ '/play',video.key] " title="{{ video.title }}">{{ video.title }}</a></div>
    <div class="d-flex justify-content-between" *ngIf="!hasWatched">
      <div>
        <div class="tag-text text-light">
          <span>{{niceTag}}</span> 
        </div>
        <!-- <div *ngIf="!video.tags" class="tag-text text-light">
          <span>{{ video.cidMapper !== '' ? replaceComma(video.cidMapper) : video.cid }}</span>
        </div>
        <div *ngIf="!!video.tags && video.tags.length>0" class="tag-text text-light ">
          <span>{{ video.cidMapper !== '' ? replaceComma(video.cidMapper) : video.tags.join('　') }}</span>
        </div> -->
      </div>
      <div *ngIf="!video.isFilm && !video.isDocumentry">
        <div *ngIf="!!video.lastName" class="text-light mr-2" style="line-height: 22px;" title="{{video.lastName}}">
          <ng-container *ngIf="video.isSerial === true || video.inProgress === true">
            <div class="status-text mr-1">更新 {{video.lastName}} </div>
          </ng-container>
          <div class="status-text mr-1" *ngIf="video.isSerial === false || video.inProgress === false">
            {{video.lastName}}</div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between" *ngIf="hasWatched">
      <div class="tag-text text-light watched-at" style="font-size: 12px; line-height: 22px;" title="{{ video.lastTitle }}">
        看到 {{ video.lastTitle }}
      </div>
      <div *ngIf="!!video.lastName" class="text-light mr-2" style="line-height: 22px;" title="{{video.lastName}}">
        <ng-container *ngIf="video.isSerial === true || video.inProgress === true">
          <div class="status-text mr-1">更新 {{video.lastName}} </div>
        </ng-container>
        <div class="status-text mr-1" *ngIf="video.isSerial === false || video.inProgress === false">
          {{video.lastName}}</div>
      </div>
    </div>
  </div>
</div>

<ng-content></ng-content>